import { ref } from 'vue';
export const crmmFeatures = ref({});
let loaded = false;
export async function loadCrmmFeatures() {
  if (loaded) return crmmFeatures.value;
  loaded = true;
  try {
    const accountId = window.location.pathname.split('/')[3];
    const res = await window.axios.get('/api/v1/accounts/' + accountId + '/crmm/config');
    crmmFeatures.value = (res.data && res.data.features) || {};
  } catch (e) { crmmFeatures.value = {}; }
  return crmmFeatures.value;
}
